/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M15.8359 4.16732L4.16927 15.834M7.5026 5.41732C7.5026 6.56791 6.56986 7.50065 5.41927 7.50065C4.26868 7.50065 3.33594 6.56791 3.33594 5.41732C3.33594 4.26672 4.26868 3.33398 5.41927 3.33398C6.56986 3.33398 7.5026 4.26672 7.5026 5.41732ZM16.6693 14.584C16.6693 15.7346 15.7365 16.6673 14.5859 16.6673C13.4353 16.6673 12.5026 15.7346 12.5026 14.584C12.5026 13.4334 13.4353 12.5007 14.5859 12.5007C15.7365 12.5007 16.6693 13.4334 16.6693 14.584Z" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
